/**
 * What a phone is called on screen: the name a person gave it, else the model, else the serial.
 *
 * One function so every panel agrees: a phone renamed on the Machines page must be that name on the
 * workspace card, in the Distribute dialog, in a toast — or the person is left matching models by hand.
 */

import type { Device } from '../../api/types'

export function phoneName(d: Pick<Device, 'name' | 'model' | 'serial'>): string {
  return d.name ?? d.model ?? d.serial
}
